import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComments = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6647_25542)",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.45605 0.703125C4.41025 0.703125 2.94217 1.38453 1.97969 2.45764C1.02005 3.52752 0.559652 4.99937 0.559652 6.62153C0.559652 8.21945 1.01197 9.67801 1.96097 10.7418C1.69213 11.7679 1.15813 12.3094 1.15813 12.3094L0.507812 12.9536L1.42237 12.9932C1.42237 12.9932 3.11097 13.0572 4.29877 12.2059C4.93029 12.3996 5.64853 12.5063 6.45885 12.5063C8.51381 12.5063 9.98221 11.8206 10.9428 10.75C11.9012 9.68188 12.3573 8.21809 12.3573 6.62153V6.62133C12.3558 4.99921 11.8987 3.5276 10.9406 2.45784C9.97957 1.3848 8.51117 0.703125 6.45605 0.703125ZM6.45605 1.50312C8.23297 1.50312 9.51373 2.06381 10.3446 2.99156C11.1785 3.92261 11.5559 5.21012 11.5573 6.62172C11.5572 8.00908 11.1801 9.28761 10.3473 10.2158C9.51665 11.1416 8.23589 11.7063 6.45885 11.7063C5.65813 11.7063 4.95801 11.5926 4.35305 11.3821L4.13849 11.3075L3.96449 11.4536C3.44713 11.8878 2.77097 12.0696 2.25121 12.1446C2.45173 11.7905 2.66233 11.3104 2.79081 10.7091L2.83569 10.499L2.68537 10.3456C1.77161 9.41289 1.35965 8.08009 1.35965 6.62153C1.35965 5.21009 1.74025 3.92272 2.57521 2.9918C3.40733 2.06408 4.68741 1.50312 6.45605 1.50312Z"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.1387 8.08529C13.3194 8.07189 13.506 8.06529 13.6986 8.06557H13.6989C15.4678 8.06557 16.7484 8.62649 17.581 9.55437C18.4165 10.4854 18.7975 11.7732 18.7975 13.1856C18.7975 14.6446 18.3851 15.977 17.4717 16.9102L17.3216 17.0635L17.3663 17.2734C17.4946 17.8748 17.7052 18.3549 17.9058 18.709C17.3861 18.6339 16.7101 18.4521 16.1927 18.0179L16.0186 17.8719L15.8041 17.9466C15.1995 18.157 14.4991 18.2704 13.6984 18.2704C11.9218 18.27 10.6417 17.7049 9.81169 16.7789C8.97937 15.8502 8.60273 14.5713 8.60273 13.1836H7.80273C7.80273 14.7803 8.25829 16.2443 9.21597 17.3128C10.1759 18.3838 11.6436 19.0699 13.6983 19.0704H13.6983C14.5086 19.0704 15.2272 18.964 15.8585 18.7704C17.0466 19.6217 18.7348 19.5576 18.7348 19.5576L19.6497 19.518L18.999 18.8737C18.999 18.8737 18.4647 18.3323 18.1961 17.3063C19.1449 16.2421 19.5975 14.7839 19.5975 13.1856C19.5975 11.5623 19.1366 10.0901 18.1765 9.02009C17.2135 7.94693 15.7451 7.26565 13.6996 7.26557C13.4863 7.26529 13.2797 7.27261 13.0795 7.28745L13.1387 8.08529Z"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6647_25542",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgComments);
export default ForwardRef;
